import PortalStandardComponent from '@/components/portal/PortalStandardComponent.tsx'
import StatsPanel from '@/components/Stats/StatsPanel.tsx'
import StatHistoryList from '@/components/Stats/StatHistoryList.tsx'

export default function StatsPage() {
  // No filters — everything the account owns.
  return (
    <PortalStandardComponent
      title='Statistiken'
      noCard
      description='Was in deinen Galerien, geteilten Links und Portfolios passiert.'
    >
      <StatsPanel>
        <StatHistoryList showDriveTitle />
      </StatsPanel>
    </PortalStandardComponent>
  )
}
